import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./CompanyStyle.css";

import {
  INTRODUCED,
  CANDIDATE_INTERESTED,
  CANDIDATE_NOT_INTERESTED,
  CONFIRMING_CANDIDATE_INTEREST,
} from "../../../constants/introPriorities";
import utils from "../../../services/utils.service";
import {
  acceptCompany,
  submitCompany,
  rejectCompany,
} from "../../../actions/introActions";
import { showModal } from "../../../actions/modalActions";
import { FormGroup } from "../../../styles/form";
import BaseModal from "../BaseModal";
import MessageModal from "../MessageModal";
import {
  ModalContent,
  Form,
  Header,
  ButtonContainer,
  TextArea,
  CloseIcon,
} from "../modal.styles";
import {
  InterestedButton,
  PassButton,
  Content,
  ModalTitle,
  Statement,
} from "./CompanyModal.styles";
import CompanyInfo from "./CompanyInfo";
import RoleSelect from "./RoleSelect";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga";

class CompanyModal extends React.Component {
  constructor(props) {
    super(props);
    const modalData = utils.clone(this.props.modalData);
    let { name: CompanyName } = modalData.new_comp;
    this.props.history.push(
      `/companies/${CompanyName.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase()}`
    );
    const activePositions = modalData.new_comp.positions.filter(
      (p) => p.status === "Active"
    );
    this.state = {
      company: modalData.new_comp,
      intro: modalData.new_intro,
      interest_blurb: modalData.new_intro.other_data.member_interest_blurb,
      role:
        modalData.new_intro.other_data.position_id ||
        (activePositions.length > 0 ? activePositions[0].id : null),
      showMessage: "",
      acceptedCompany:
        modalData.new_intro.other_data.member_status === CANDIDATE_INTERESTED,
    };
    this.handleAccept = this.handleAccept.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.handleInterestChange = this.handleInterestChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);

    console.log(modalData);
    console.log(this.state);
  }

  closeModal() {
    this.props.history.goBack();
    this.props.onHideClick();
  }

  handleInterestChange(e) {
    this.setState({ interest_blurb: e.target.value });
    this.props.modalData.new_intro.other_data.member_interest_blurb =
      e.target.value;
  }

  handleRoleChange(value) {
    this.setState({ role: value });
  }

  hideMessage = () => {
    this.setState({ showMessage: "" });
  };

  // when a company is accepted
  handleAccept() {
    if (!this.state.role && this.state.company.positions.length > 0) {
      this.setState({ showMessage: { title: "Please select a role" } });
      return;
    }
    ReactGA.event({
      category: "CANDIDATE_ACTION",
      action: "ACCEPTED",
      label: "COMPANY_INFO_MODAL",
    });
    this.props.acceptCompany({
      intro_id: this.state.intro.id,
      interest_blurb: this.state.interest_blurb || "",
      interest_role: this.state.role || null,
      place: "from_modal",
    });
    this.setState({
      acceptedCompany: true,
      interest_blurb: this.state.interest_blurb,
    });
    // this.props.modalData.new_intro["Position"] = [this.state.role];
    this.closeModal();
  }

  // to handle submit
  handleSubmit() {
    if (!this.state.role && this.state.company.positions.length > 0) {
      this.setState({ showMessage: { title: "Please select a role" } });
      return;
    }

    this.props.submitCompany({
      intro_id: this.state.intro.id,
      interest_blurb: this.state.interest_blurb || "",
      interest_role: this.state.role,
      place: "from_modal",
    });
    // this.props.modalData.new_intro["Position"] = [this.state.role];
    this.closeModal();
  }

  handleReject() {
    ReactGA.event({
      category: "CANDIDATE_ACTION",
      action: "REJECTED",
      label: "COMPANY_INFO_MODAL",
    });
    this.props.rejectCompany({
      intro_id: this.state.intro.id,
      interest_blurb: this.state.interest_blurb,
      place: "from_modal",
    });
    this.closeModal();
  }

  onCancelClick = () => {
    this.closeModal();
  };

  displayMessage() {
    if (this.state.showMessage !== "") {
      return (
        <MessageModal
          onHideClick={this.hideMessage}
          title={this.state.showMessage.title}
          message={this.state.showMessage.message}
        />
      );
    }
    return null;
  }

  displayTopStatement() {
    const company_name = this.state.company.name.replace(" (STEALTH)", "");
    if (this.state.acceptedCompany) {
      return (
        <Statement style={{ textAlign: "center" }}>
          You have accepted {company_name} and an introduction will be made
          soon.
        </Statement>
      );
    } else {
      return (
        <Statement style={{ textAlign: "center" }}>
          If you would like an introduction to {company_name}, please click{" "}
          <span
            style={{
              color: "#5b8926",
              display: "inline-block",
              fontStyle: "italic",
            }}
          >
            Interested
          </span>
          .
        </Statement>
      );
    }
  }

  renderButton() {
    switch (this.state.intro.other_data.member_status) {
      case INTRODUCED:
        return (
          <ButtonContainer>
            <InterestedButton disabled onClick={this.handleSubmit}>
              Submit
            </InterestedButton>
            {/* <PassButton disabled onClick={this.handleReject}>Pass</PassButton> */}
          </ButtonContainer>
        );
      case CANDIDATE_INTERESTED:
        return (
          <ButtonContainer>
            <InterestedButton onClick={this.handleSubmit}>
              Submit
            </InterestedButton>
            {/* <PassButton disabled onClick={this.handleReject}>Pass</PassButton> */}
          </ButtonContainer>
        );
      case CANDIDATE_NOT_INTERESTED:
        return (
          <ButtonContainer>
            <InterestedButton onClick={this.handleAccept}>
              Interested
            </InterestedButton>
            <PassButton disabled onClick={this.handleReject}>
              Pass
            </PassButton>
          </ButtonContainer>
        );
      case CONFIRMING_CANDIDATE_INTEREST:
        return (
          <ButtonContainer>
            <InterestedButton onClick={this.handleAccept}>
              Interested
            </InterestedButton>
            <PassButton onClick={this.handleReject}>Pass</PassButton>
          </ButtonContainer>
        );
      default:
        return (
          <ButtonContainer>
            <InterestedButton onClick={this.handleSubmit}>
              Submit
            </InterestedButton>
            {/* <PassButton disabled onClick={this.handleReject}>Pass</PassButton> */}
          </ButtonContainer>
        );
    }
  }

  render() {
    const { company } = this.state;
    return (
      <React.Fragment>
        <BaseModal onHideClick={this.closeModal}>
          <ModalContent className="company-section">
            <Header colour={"white"} style={{ position: "relative" }}>
              {company.logo_link ? (
                <img
                  alt=""
                  height="50"
                  width="50"
                  src={company.logo_link}
                ></img>
              ) : null}
              <ModalTitle>{company.name}</ModalTitle>
              <CloseIcon
                className={"fas fa-times"}
                style={{
                  color: "darkgrey",
                  position: "absolute",
                  right: "6px",
                  top: "0px",
                }}
                onClick={this.closeModal}
              />
            </Header>
            <div
              className="alert-info"
              style={{ boxShadow: "0 0 3px rgba(0, 0, 0, 0.1)" }}
            >
              {this.displayTopStatement()}
            </div>
            <Content>
              <CompanyInfo companyInfo={company} />
              <div className="info-section">
                <h3 className="sub-title">Statement of Interest</h3>
                <hr />
              </div>
              <Form>
                <FormGroup>
                  {company.positions.length > 0 ? (
                    <React.Fragment>
                      <Statement>
                        1. Please choose a position you are interested in:
                      </Statement>
                      <RoleSelect
                        roles={company.positions.filter(
                          (p) => p.status && p.status.toUpperCase() === "ACTIVE"
                        )}
                        role={this.state.role}
                        onRoleChanged={this.handleRoleChange}
                      />
                    </React.Fragment>
                  ) : null}
                  <Statement>
                    {company.positions.length > 0 ? "2" : "1"}. We encourage you
                    to put together a short blurb indicating your unique
                    interest in this company and opportunity, ideally
                    highlighting a) your understanding of the
                    company/opportunity, b) your background/motivations and c)
                    your view on a potential match. Ideally this is 2-3
                    sentences, akin to the below:{"\n"}
                  </Statement>{" "}
                  <br />
                  <TextArea
                    rows="4"
                    name="notes"
                    value={this.state.interest_blurb || ""}
                    disabled={
                      this.state.intro.other_data.member_status === INTRODUCED
                    }
                    onChange={this.handleInterestChange}
                    placeholder="e.g. X company’s mission to democratize access to canines for puppy aficionados resonates with me, while in school I fostered multiple dogs and built a side project connecting students with puppies for weekend stays as an experiment in developing a two-sided matching engine in Ruby and Rust. Your founder’s personal story is inspiring, and I think my prior experiences and desire to build both front and back end product could align well."
                  />
                </FormGroup>
              </Form>
            </Content>
            {this.renderButton()}
          </ModalContent>
        </BaseModal>
        {this.displayMessage()}
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      acceptCompany,
      submitCompany,
      rejectCompany,
      showModal,
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(withRouter(CompanyModal));



// WEBPACK FOOTER //
// ./src/components/Modals/Company/CompanyModal.js